import { PropsWithChildren } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type FormFieldsetProps = PropsWithChildren<
	WithClassName<{
		title: string
	}>
>

export const FormFieldset = ({ title, className, children }: FormFieldsetProps) => (
	<section className="rounded-lg border border-border bg-muted/30 p-4 sm:p-5">
		<h3 className="mb-4 font-display text-[13px] font-semibold text-foreground">{title}</h3>
		<div className={cn('grid gap-4', className)}>{children}</div>
	</section>
)
